export const GLOBAL_EVENT_CREATE_LEAVE_WARNING = "leaveWarning";

export const GLOBAL_EVENT_SHOW_SETTINGS = "settings";

export const GLOBAL_EVENT_LOGOUT = "logout";

export const GLOBAL_EVENT_PERMISSION_DENIED = "permissionDenied";

export const GLOBAL_EVENT_NOTE_CREATED = (dataType, dataId, noteType) =>
  `${dataType}-${dataId}-${noteType}-noteCreated`;

export const GLOBAL_EVENT_NOTE_LIBRARY_REMOVAL = (dataId, dataType) =>
  `notes-library-${dataType}-${dataId}-note-removed`;

export const GLOBAL_EVENT_NOTE_LIBRARY_UPDATED = (dataId, dataType) =>
  `notes-library-${dataType}-${dataId}-note-updated`;

export const GLOBAL_EVENT_NOTE_TYPE_CHANGED = (dataType, dataId, noteType) =>
  `${dataType}-${dataId}-${noteType}-noteUpdated`;

export const GLOBAL_EVENT_SHOW_ROLE_CHANGE_MODAL = "show role change modal";
